<template>
    <baidu-map class="map" :center="{lng: 121.495324, lat: 29.954635}" :zoom="15">
        <bm-info-window :position="{lng: 121.495324, lat:29.954635}" title="" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen">
            <div style="display: flex;flex-direction: row;align-items: center">
                <img src="../asset/aike/wz.png" alt="">
                <span style="display: inline-block;margin-left: 10px;color:#0C4EA2;font-size: 23px;font-family: 'SOURCEHANSANSCN-REGULAR'">{{$t('contact').map[0]}}</span>
            </div>
            <p style="color:#0C4EA2;font-size: 18px;font-family: 'SOURCEHANSANSCN-NORMAL';margin: 10px auto;">{{$t('contact').map[1]}}</p>
        </bm-info-window>
    </baidu-map>
</template>

<script>

    export default {
        data () {
            return {
                infoWindow: {
                    show: true,
                    contents: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                }
            }
        },
        methods: {
            infoWindowClose (e) {
                this.infoWindow.show = false
            },
            infoWindowOpen (e) {
                this.infoWindow.show = true
            },
            clear () {
                this.infoWindow.contents = ''
            }
        }
    }
</script>
<style scoped>
    .map{
        margin: 0 auto;
        width:80%;
        height:500px;
    }
    @media screen and (max-width:1000px) {
        
        .map div span{
            font-size: 16px !important;
        }
        .map p{
            font-size: 14px !important;
        }
    }
</style>
